// extracted by mini-css-extract-plugin
module.exports = {"detail":"wxActRule_detail_2J2-6","box":"wxActRule_box_3Jq0-","title":"wxActRule_title_3oJ3Q","time":"wxActRule_time_3rtTp","content":"wxActRule_content_3wgZw"};